import {GETSTATSCHAT, GETCHATPERSON, GETCHATPERSONONE, GETSPECIALSTATS, GETSPECIALEVENTS, GETONESPECIALEVENTS, GETCHATEVENTFILTER} from '../actions/constant';

const INITIAL_STATE = {stats: {}, personsList: {}, chat_person_one: {}, special_events: {}, special_event_one: {}, special_event_stat: []};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case GETSTATSCHAT:
            return {...state, stats:action.payload.data};
        case GETCHATPERSON:
            return {...state, personsList:action.payload.data};
        case GETCHATPERSONONE:
            return {...state, chat_person_one:action.payload.data};
        case GETSPECIALSTATS:
            return {...state, special_event_stat:action.payload.data};
        case GETSPECIALEVENTS:
            return {...state, special_events:action.payload.data};
        case GETCHATEVENTFILTER:
            return {...state, special_events:action.payload.data};
        case GETONESPECIALEVENTS:
            return {...state, special_event_one:action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_chat.js